<template>
  <div>
    <h2>User Management</h2>

    <v-card class="pa-2 mt-5 d-flex">
      <v-text-field
        outlined
        hide-details
        v-model="search"
        label="Search list"
        prepend-inner-icon="mdi-account-search"
      ></v-text-field>
      <v-btn
        icon
        x-large
        text
        class="ml-2 mt-1 mr-1"
        color="green"
        :to="{ name: 'createAccount' }"
      >
        <!-- @click="createAccount = true" -->
        <v-icon>mdi-account-plus </v-icon>
      </v-btn>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="filteredUsers"
      :items-per-page="10"
      class="elevation-1 mt-5 mb-8"
    >
      <template v-slot:[`item.createdAt`]="{ item }">
        <small>{{ formatDate(item.createdAt) }}</small>
      </template>
      <template v-slot:[`item.firstName`]="{ item }">
        <span style="white-space: nowrap">
          <v-tooltip v-if="item.active" bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="green" v-bind="attrs" v-on="on">
                mdi-check-circle-outline
              </v-icon>
            </template>
            <span>active user</span>
          </v-tooltip>

          <v-tooltip v-else bottom color="error">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="red" v-bind="attrs" v-on="on">
                mdi-close-circle-outline
              </v-icon>
            </template>
            <span>inactive user</span>
          </v-tooltip>

          {{ item.title }} {{ item.firstName }} {{ item.lastName }}
        </span>
      </template>
      <!-- <template v-slot:[`item.active`]="{ item }">
        <v-checkbox
          disabled
          hide-details
          color="green"
          v-model="item.active"
          class="shrink mr-2 mt-0"
        >
        </v-checkbox>
      </template> -->
      <template v-slot:[`item.roles`]="{ item }">
        <v-chip
          x-small
          color="yellow lighten-3"
          class="text-uppercase ma-1"
          v-for="role in item.roles"
          :key="role"
        >
          {{ role }}
        </v-chip>
      </template>
      <template v-slot:[`item._id`]="{ item }">
        <!-- <v-btn
          small
          outlined
          color="blue"
          class="ma-1"
          @click="openDetailsDialog(item._id)"
        >
          Update
        </v-btn> -->

        <span style="white-space: nowrap">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="blue"
                class="ma-1"
                v-bind="attrs"
                v-on="on"
                @click="openDetailsDialog(item._id)"
              >
                <v-icon>mdi-account-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>update info</span>
          </v-tooltip>

          <!-- <v-btn icon color="red" class="ma-1">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn> -->
        </span>
      </template>
    </v-data-table>

    <AccountDetails
      :account="selectedUser"
      @refresh="fetchUsers"
      @cancel="selectedUser = null"
    />

    <!-- <CreateAccount
      @refresh="fetchUsers"
      :open="createAccount"
      @cancel="createAccount = false"
    /> -->
  </div>
</template>

<script>
import { formatDateOnly } from "../../../tools/format";
import AccountDetails from "./Dialogs/AccountDetails";
// import CreateAccount from "./Dialogs/CreateAccount";

export default {
  components: { AccountDetails },

  data: () => ({
    loading: false,
    createAccount: false,

    users: [],

    search: "",

    headers: [
      { text: "Registered", value: "createdAt" },
      { text: "Full Name", align: "start", value: "firstName" },
      { text: "Institution", value: "institution" },
      { text: "Email", value: "email" },
      { text: "Roles", value: "roles" },
      { text: "Actions", value: "_id", sortable: false },
    ],

    selectedUser: null,
  }),
  computed: {
    filteredUsers() {
      return [...this.users].filter((user) => {
        const term = this.search.toLowerCase();
        return (
          user.title.toLowerCase().includes(term) ||
          user.lastName.toLowerCase().includes(term) ||
          user.firstName.toLowerCase().includes(term) ||
          (user.institution && user.institution.toLowerCase().includes(term)) ||
          (user.specialization &&
            user.specialization.toLowerCase().includes(term)) ||
          user.roles.join("").toLowerCase().includes(term)
        );
      });
    },
  },
  methods: {
    formatDate: formatDateOnly,
    fetchUsers() {
      this.loading = true;
      this.$axios
        .get("/users")
        .then(({ data: response }) => {
          this.users = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve users",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDetailsDialog(account) {
      this.$forceUpdate();
      this.selectedUser = account;
    },
  },
  mounted() {
    this.fetchUsers();
  },
};
</script>

<style>
</style>